import { createTheme } from '@mui/material/styles'
import { renderTimeViewClock } from '@mui/x-date-pickers'

const palette = {
  background: {
    default: '#eaeff1',
    card: '#fafafa',
    grey1: 'rgba(236,239,241,.38)',
    menu: '#051e34',
  },
  grey: {
    50: '#ffffff',
    600: '#e8e8e8',
    700: '#b5b5b5',
    800: '#8c8c8c',
    900: '#6b6b6b',
  },
  primary: {
    main: '#0167FF',
    light: '#2A7FFF',
    dark: '#0157D6',
    divider: 'rgb(42, 72, 101)',
  },
  secondary: {
    main: '#191935',
  },
  error: {
    main: '#FF4800',
    light: '#FF6529',
    dark: '#D63C00',
  },
  warning: {
    main: '#FFE469',
  },
  info: {
    main: '#0167ff',
  },
  success: {
    main: '#159200',
    light: '#3AA329',
    dark: '#127B00',
  },
  action: {
    primary: '#0167ff',
    secondary: '#0b0b16',
  },
}

const theme = createTheme({
  palette,
  typography: {
    useNextVariants: true,
    fontFamily: 'Roboto Flex',
    h1: {
      fontSize: '2rem',
      fontWeight: 600,
      marginBottom: '2rem',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: 26,
      fontWeight: 600,
      letterSpacing: 0.5,
    },
    subtitle1: {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 300,
    },
    body2: {
      fontSize: '1rem',
    },
    caption: {
      display: 'block',
    },
  },
  shape: {
    borderRadius: 8,
  },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
  components: {
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          minWidth: 40,
          textTransform: 'none',
          borderRadius: 4,
        },
        label: {
          textTransform: 'none',
        },
        contained: {
          boxShadow: 'none',
          '&:active': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiDesktopDateTimePicker: {
      defaultProps: {
        viewRenderers: {
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        },
      },
    },
    MuiDesktopTimePicker: {
      defaultProps: {
        viewRenderers: {
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        },
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: '#404854',
      },
    },
    MuiDrawer: {
      paper: {
        backgroundColor: '#18202c',
      },
    },
    MuiIconButton: {
      root: {
        padding: 1,
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          cursor: 'pointer',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
        },
      },
    },
    MuiTabs: {
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: '#ffffff',
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          margin: '0 16px',
          minWidth: 0,
          padding: 0,
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiListItemText: {
      primary: {
        fontWeight: 500,
      },
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
        marginRight: 0,
        '& svg': {
          fontSize: 20,
        },
      },
    },
  },
})

export default theme
